<div class="card">
    <div class="card-header bg-primary text-white">
        <div class="row align-items-center">
            <p class="h3 m-0 col">Key contacts</p>
            <div class="col text-right">
                <button class="btn btn-outline-light btn-sm ml-2" (click)="add()">
                    Create key contact <i class="ml-2 fa fa-plus"></i>
                </button>
            </div>
        </div>
    </div>
    <div class="card-body">
        <table class="table mb-0">
            <colgroup>
                <col class="col-auto">
                <col class="col-auto">
                <col class="col-auto">
                <col class="col-auto">
            </colgroup>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Location</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let contact of keyContacts">
                    <td [ngClass]="{'text-muted strikethrough': contact.disabled}">{{contact.name}}</td>
                    <td [ngClass]="{'text-muted strikethrough': contact.disabled}"><strong>{{contact.email}}</strong></td>
                    <td [ngClass]="{'text-muted strikethrough': contact.disabled}">{{contact.location}}</td>
                    <td class="text-right">
                        <i class="btn btn-primary-invert fa fa-pencil" (click)="editClicked(contact)"></i>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
